import { render, staticRenderFns } from "./BasicDialog.vue?vue&type=template&id=68bb19cb"
import script from "./BasicDialog.vue?vue&type=script&lang=js"
export * from "./BasicDialog.vue?vue&type=script&lang=js"
import style0 from "./BasicDialog.vue?vue&type=style&index=0&id=68bb19cb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports